import React, { Children } from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  initials: 'JR',
  stars: 5,
  highlight: 'Organizado en 1 día',
  quote: 'Compré un martes a la noche. El miércoles tenía todo el año organizado. Las sesiones del Tomo 1 son exactamente lo que necesitaba. Ya no improviso nada.',
  name: 'José R.',
  location: 'Ciudad de México',
  level: 'Academia barrial'
}, {
  initials: 'MG',
  stars: 5,
  highlight: 'Cero quejas de padres',
  quote: 'Las planillas de evaluación me cambiaron la relación con los padres. Ahora les muestro un informe mensual con evidencia real. Cero quejas, más renovaciones.',
  name: 'Marcela G.',
  location: 'Buenos Aires',
  level: 'Coordinadora técnica'
}, {
  initials: 'LV',
  stars: 5,
  highlight: 'Retención del 45% al 88%',
  quote: 'Sin cambiar los precios, solo aplicando el sistema de retención. Los padres ahora recomiendan la academia activamente.',
  name: 'Laura V.',
  location: 'Santiago de Chile',
  level: 'Directora de academia'
}, {
  initials: 'FT',
  stars: 5,
  highlight: 'Escaló a 3 escuelas',
  quote: 'Apliqué el sistema en 3 escuelas al mismo tiempo. El banco de ejercicios me permite alinear a todos los entrenadores sin reuniones interminables.',
  name: 'Felipe T.',
  location: 'Lima',
  level: 'Coordinador municipal'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-[#111111] py-12 sm:py-24 px-4 overflow-hidden" data-id="element-306">
      <div className="max-w-2xl mx-auto" data-id="element-307">
        <motion.div className="text-center mb-8 sm:mb-12" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} data-id="element-308">
          <h2 className="text-2xl sm:text-4xl font-black text-white mb-2 sm:mb-3 leading-tight" data-id="element-309">
            Lo que dicen los entrenadores{' '}
            <span className="text-[#22C55E]" data-id="element-310">que ya lo usan</span>
          </h2>
          <p className="text-gray-400 text-xs sm:text-base" data-id="element-311">
            +500 entrenadores en el mundo hispanohablante ya tienen su Megapack
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4" initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-40px'
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.1
          }
        }
      }} data-id="element-312">
          {testimonials.map((test, i) => <motion.div key={i} variants={{
          hidden: {
            opacity: 0,
            y: 16
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.4,
              ease: 'easeOut'
            }
          }
        }} className="relative bg-white/[0.02] border border-white/[0.05] hover:border-[#22C55E]/30 rounded-2xl p-4 sm:p-5 flex flex-col gap-2.5 transition-colors duration-300 group" data-id="element-313">
              <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#22C55E]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-314" />

              {/* Header: avatar + name + location */}
              <div className="flex items-center gap-2.5" data-id="element-315">
                <div className="w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-[#22C55E]/10 border border-[#22C55E]/30 flex items-center justify-center text-[#22C55E] font-black text-[10px] sm:text-xs flex-shrink-0" data-id="element-316">
                  {test.initials}
                </div>
                <div className="min-w-0 flex-1" data-id="element-317">
                  <div className="flex items-center gap-1.5" data-id="element-318">
                    <span className="text-white font-bold text-xs sm:text-sm leading-tight" data-id="element-319">
                      {test.name}
                    </span>
                    <span className="text-[#22C55E] text-[8px] sm:text-[10px] tracking-wider" data-id="element-320">
                      ⭐⭐⭐⭐⭐
                    </span>
                  </div>
                  <div className="text-gray-500 text-[10px] sm:text-[11px]" data-id="element-321">
                    📍 {test.location} · {test.level}
                  </div>
                </div>
              </div>

              {/* Highlight result tag */}
              <span className="inline-flex self-start items-center gap-1 bg-[#22C55E]/10 text-[#22C55E] text-[10px] sm:text-xs font-bold px-2.5 py-1 rounded-md border border-[#22C55E]/20" data-id="element-322">
                📈 {test.highlight}
              </span>

              {/* Quote */}
              <p className="text-gray-300 text-xs sm:text-sm leading-relaxed italic" data-id="element-323">
                "{test.quote}"
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}